import React from "react";

export function Section({ title, desc, right, children, testId, className = "" }) {
  return (
    <div className={`border border-border rounded-xl bg-card p-6 ${className}`} data-testid={testId}>
      <div className="flex items-start justify-between gap-4 mb-5">
        <div>
          <div className="font-display font-bold text-lg">{title}</div>
          {desc && <div className="text-sm text-muted-foreground mt-0.5">{desc}</div>}
        </div>
        {right}
      </div>
      {children}
    </div>
  );
}
